__turbopack_context__.v({
  "gsiMaterialButtonConnected": "google-buttons-module__GFc4iG__gsiMaterialButtonConnected",
  "gsiMaterialButtonConnectedIcon": "google-buttons-module__GFc4iG__gsiMaterialButtonConnectedIcon",
  "gsiMaterialButtonNavbar": "google-buttons-module__GFc4iG__gsiMaterialButtonNavbar",
  "gsiMaterialButtonNavbarContentWrapper": "google-buttons-module__GFc4iG__gsiMaterialButtonNavbarContentWrapper",
  "gsiMaterialButtonNavbarContents": "google-buttons-module__GFc4iG__gsiMaterialButtonNavbarContents",
  "gsiMaterialButtonNavbarIcon": "google-buttons-module__GFc4iG__gsiMaterialButtonNavbarIcon",
  "gsiMaterialButtonNavbarState": "google-buttons-module__GFc4iG__gsiMaterialButtonNavbarState",
});
